var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("用户: "+_vm._s(_vm.userName)+"       当前时间："+_vm._s(_vm.currentTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }